/**
 * Helper-Funktionen für Formulare.
 * Zentrale Logik zur Ermittlung der initial vorzubelegenden Firmen-ID.
 * 
 * Regeln (Issue #333):
 * 1. Wenn global.filterFirmenId > 0 (User hat explizit eine Firma ausgewählt) 
 *    → diese verwenden
 * 2. Wenn filterFirmenId === 0 UND User ist fest einer Firma zugeordnet 
 *    → global.auth.user.firmenId verwenden
 * 3. Sonst → null (Feld leer lassen, kein Fallback auf erste Firma!)
 */

export function getInitialFirmenId() {
  if (global.filterFirmenId > 0) {
    return global.filterFirmenId;
  }
  
  if (global.filterFirmenId === 0 && global.auth?.user?.firmenId) {
    return global.auth.user.firmenId;
  }
  
  return null;
}
